import * as _ from 'lodash';

const isValIncluded = item => (value, key) => _.includes(value, _.get(item, key, null));
const isValid = filters => item => _.every(filters, isValIncluded(item));

export const filterCol = coll => filters => _.filter(coll, isValid(filters));
